import * as React from 'react';
import Icon from 'src/core/ui/icon';

export interface TooltipProps {
    content?: any;
    trigger?: any;
    color?: string;
    action?: 'hover'|'click';
    className?: string;
}

export interface TooltipState {
    show: boolean;
}

export default class Tooltip extends React.Component<TooltipProps, TooltipState> {
  constructor(props: TooltipProps) {
    super(props);

    this.state = {
        show: false
    }
  }

  show = () => {
    this.setState({show: true})
  }

  hide = () => {
      this.setState({show: false})
  }

  toggle = () => {
      this.setState({show: !this.state.show})
  }


  public componentDidMount(){
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  wrapperRef: any;

  handleClickOutside = (event) => {

    const action = this.props.action || 'click';
       if (this.wrapperRef != undefined){
         if(event
           && !this.wrapperRef.contains(event.target) 
           && action == 'click'
           && this.state.show) {
         this.toggleContent();
       }
     }
   }
   public toggleContent = () =>{
     this.setState({show: !this.state.show})
   }

  public render() {

    const action = this.props.action || 'click';

    const props = {
        onClick: action == 'click'? this.toggle : undefined,

    }

    return (
      <div ref={e => this.wrapperRef = e} className={'tooltip ' + (this.props.className || '')}>
        <div className='tooltip-trigger'  {...props} >
            {this.props.trigger}
        </div>
        {this.state.show &&<div className='tooltip-content'>
            {this.props.content}
        </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/core/ui/tooltip.tsx